import { useCallback, useEffect, useState } from "react";
import { IoAdd, IoTrash } from "react-icons/io5";
import Toaster from "./../../../components/common/Toaster";
import Modal from "../../../components/common/Modal";
import RemoveMember from "./RemoveMember";
import AddMember from "./AddMember";
import chatService from "../../../services/chatService";

const RoomSettings = ({ room }) => {
  const [selectedMember, setSelectedMember] = useState(null);

  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const fetchMembers = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const { result } = await chatService.getRoomMembersAsync(room.id);

        if (mounted) {
          setMembers(result);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
      }
    },
    [room]
  );

  useEffect(() => {
    let mounted = true;

    fetchMembers(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchMembers, refresh]);

  const handelConfirmation = (item) => {
    if (item) {
      setSelectedMember(item);
      setShowDeleteForm(true);
      return;
    }

    setSelectedMember(null);
    setShowDeleteForm(false);
  };

  const handleDelete = async (item) => {
    const { id } = item;
    const original_members = members;
    const updated_members = original_members.filter((i) => i.id !== id);

    setMembers(updated_members);
    handelConfirmation();

    try {
      await chatService.removeUserAsync(id);
      Toaster.Success(`${item.name} removed successfully`);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  const handleSuccess = () => {
    setRefresh(!refresh);
    setShowForm(false);
  };

  // TODO: Render file list

  return (
    <div className="p-5">
      <div className="text-gray-400 text-sm">Participants</div>
      {isLoading && (
        <div className="w-full">
          <div className="flex-1 space-y-2 animate-pulse px-6 py-5">
            <div className="h-4 bg-gray-100 rounded w-28"></div>
            <div className="h-4 bg-gray-100 rounded w-32"></div>
          </div>
        </div>
      )}
      <div className="flex flex-wrap space-x-1 overflow-hidden px-2 py-5">
        {members.map((item, index) => {
          return (
            <div key={index} className="has-tooltip cursor-pointer">
              <div className="relative group">
                {item.role !== "User" && item.role !== "Super User" && (
                  <div
                    onClick={() => handelConfirmation(item)}
                    className="absolute inset-0 bg-gray-50 z-10 opacity-0 group-hover:opacity-90 h-8 w-8 rounded-full flex justify-center items-center"
                  >
                    <IoTrash className="text-red-500 text-sm" />
                  </div>
                )}
                <div className="relative">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-gray-300">
                    <span className="text-white text-sm">
                      {item.name.charAt(0)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="tooltip bg-gray-50 border mt-5 rounded">
                <span className="text-sm px-2 text-gray-500">{item.name}</span>
              </div>
            </div>
          );
        })}
        <div
          onClick={() => setShowForm(true)}
          className="flex items-center justify-center cursor-pointer h-8 w-8 rounded-full border border-dashed border-blue-300"
        >
          <IoAdd className="text-blue-500" />
        </div>
      </div>
      <Modal
        title="Add Member"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <AddMember
          room={room}
          isLoading={isFormLoading}
          setIsLoading={setIsFormLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
      {selectedMember && (
        <Modal
          isOpen={showDeleteForm}
          isLoading={isFormLoading}
          onClose={() => handelConfirmation()}
        >
          <RemoveMember
            member={selectedMember}
            onDelete={handleDelete}
            onClose={() => handelConfirmation()}
          />
        </Modal>
      )}
    </div>
  );
};

export default RoomSettings;
